import { useEffect, useState } from "react";

const ShippingAddressSection = ({
  addressdata = [],
  setShowAddAddressModal,
  setDefultAddr,            // 👈 receive from parent
  selectedAddressId,        // 👈 receive from parent
  setSelectedAddressId,     // 👈 receive from parent
}) => {
  const [expanded, setExpanded] = useState(false);

  //  Auto select default address & send to parent
  useEffect(() => {
    if (addressdata.length > 0) {
      const defaultAddr = addressdata.find((a) => a.is_default);

      if (defaultAddr) {
        setSelectedAddressId(defaultAddr.id);
        setDefultAddr(defaultAddr); // 🔥 send full object to parent
      }
    }
  }, [addressdata, setSelectedAddressId, setDefultAddr]);

  const handleSelect = (addr) => {
    setSelectedAddressId(addr.id);  // store selected id in parent
    setDefultAddr(addr);            // send full address to parent
  };

  const displayedAddresses = expanded
    ? addressdata
    : addressdata.slice(0, 2);

  return (
    <div className="shipping-info-section">
      <div className="shipping-track">
        <div className="ship_info">
          <h4>SHIPPING INFORMATION</h4>
        </div>

        <button
          onClick={() => setShowAddAddressModal(true)}
          className="add_ads"
        >
          <i className="bi bi-plus" /> ADD NEW ADDRESS
        </button>
      </div>

      {displayedAddresses.map((addr) => (
        <label key={addr.id} className="address-option">
          <input
            type="radio"
            name="selectedAddress"
            checked={selectedAddressId === addr.id}
            onChange={() => handleSelect(addr)}
          />

          <div className="address-details">
            <div className="address-header_chk">
              {addr.first_name} {addr.last_name}
              <span className="address-type">
                {addr.address_type}
              </span>
            </div>

            <div className="address-body">
              {addr.address}
              {addr.address2 && `, ${addr.address2}`} <br />
              {addr.city}, {addr.state}, {addr.pincode} <br />
              {addr.country}
            </div>
          </div>
        </label>
      ))}

      {addressdata.length > 2 && (
        <button
          className="show-toggle-btn"
          onClick={() => setExpanded((prev) => !prev)}
        >
          {expanded ? "Show Less" : "Show More"}
        </button>
      )}
    </div>
  );
};

export default ShippingAddressSection;